import React, { useCallback, useState, useEffect } from "react";

const isSignInPage = () => window.location.pathname === "/signin";

const SessionExpiredPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  const performLogout = useCallback(() => {
    localStorage.removeItem("accessToken");
    window.location.href = "/signin";
  }, []);

  useEffect(() => {
    let logoutTimer;

    const handleSessionExpired = () => {
      if (isSignInPage()) return;

      setIsOpen(true);
      clearTimeout(logoutTimer);
      logoutTimer = setTimeout(performLogout, 3000);
    };

    window.addEventListener("auth:session-expired", handleSessionExpired);

    return () => {
      window.removeEventListener("auth:session-expired", handleSessionExpired);
      clearTimeout(logoutTimer);
    };
  }, [performLogout]);

  if (!isOpen || isSignInPage()) return null;
  return (
    <div style={styles.snackbar} role="status" aria-live="polite">
      <div>
        <strong style={styles.title}>Session expired</strong>
        <span style={styles.message}>Redirecting to sign in...</span>
      </div>
      <button style={styles.button} onClick={performLogout}>
        Sign in
      </button>
    </div>
  );
};

const styles = {
  snackbar: {
    position: "fixed",
    right: "24px",
    bottom: "24px",
    zIndex: 99999,
    display: "flex",
    alignItems: "center",
    gap: "16px",
    width: "min(360px, calc(100vw - 48px))",
    padding: "14px 16px",
    background: "#111827",
    color: "white",
    borderRadius: "8px",
    boxShadow: "0 12px 30px rgba(17, 24, 39, 0.22)",
    fontFamily: "system-ui, -apple-system, sans-serif",
  },
  title: {
    display: "block",
    fontSize: "0.95rem",
    lineHeight: 1.35,
    marginBottom: "2px",
  },
  message: {
    color: "#d1d5db",
    fontSize: "0.875rem",
    lineHeight: 1.35,
  },
  button: {
    flexShrink: 0,
    backgroundColor: "#dc2626",
    color: "white",
    border: "none",
    padding: "8px 12px",
    borderRadius: "6px",
    fontSize: "0.875rem",
    fontWeight: 600,
    cursor: "pointer",
  }
};

export default SessionExpiredPopup;
